import { environment } from '../environments/environment';
/* OBFUSCATE_START */

export const Constants = {
  //login
  LOGIN: 'Log In',
  SIMPLIFY_THE_CORE_JOURNEY: 'Simplify the core journey',
  ONE_PORTAL: 'one portal, one seamless process',
  CORE_RETRIEVAL_PORTAL: 'CoreConnect Portal',
  WELCOME: 'Welcome!',
  USER_ROLE: 'User Role',
  USERNAME: 'Username',
  USER_ROLE_IS_REQUIRED: 'User role is required',
  EMAIL: 'Email',
  VALID_USERNAME: 'Please enter a valid username',
  USERNAME_IS_REQUIRED: 'Username is required',
  PASSWORD: 'Password',
  PASSWORD_IS_REQUIRED: 'Password is required',
  MIN_LENGTH_6: 'Password must be at least 6 characters',
  FULL_NAME: 'Full name',
  MOBILE: 'Phone no.',
  ROLE: 'Role',
  CAPTCHA_IS_REQUIRED: 'Capcha is required',

  //dealer-list
  CORE_MANAGEMENT_LIST: 'Core Management List',
  CORE_TRACKING: 'Core Tracking',
  JOB_CARD_NO: 'Job Card No.',
  SELECT_A_JOB_CARD: 'Select a Job Card to view tracking details.',
  PREVIOUS: 'Prev',
  NEXT: 'Next',
  PREV: 'Prev',
  NO_RECORDS_FOUND: 'No Records Found',
  SUMMARY_DOCUMENT: 'Summary Document',
  QR_CODE: 'QR Code',
  WARRANTY: 'Warranty',
  PAID_EXCHANGE: 'Paid Exchange',
  EXCEL_DOWNLOAD: 'Download Excel',
  FG_INPUT: 'FG Serial number for this core is:',
  DISTRIBUTOR_EMAIL: 'Enter distributor email:',
  ENTER_EMAIL: 'Enter email:',
  ENTER_SECONDARY_EMAIL: 'Enter secondary email',
  ENTER_TERTIARY_EMAIL: 'Enter tertiary email',
  EMAIL_REQ: 'Distributor email required',
  FG_REQ: 'FG Serial Number required',

  //list-mobile
  SHOWING: 'Showing',
  OUT_OF: 'out of',
  SELECT_DOWN_OPT: 'Select Download Option',

  //dealer cl-5
  EXTERNAL_INSPECTION: 'External Inspection',
  INTERNAL_INSPECTION: 'Internal Inspection',
  REMARK: 'Remark:',
  OK: 'Ok',
  NOT_OK: 'Not Ok',
  ELIGIBLE: 'Eligible',
  NOT_ELIGIBLE: 'Not Eligible',
  DEFICIENCY_AMOUNT: 'Deficiency Amount',
  CORE_DEF_DEC_BY_DEALER: 'Core deficiency amount declared by Dealer',
  TOTAL_EX_CORE_DEF_AMT: 'Total External core deficiency amount',
  TOTAL_INT_CORE_DEF_AMT: 'Total Internal core deficiency amount',
  TOTAL_ELIGIBLE_CORE_DEF_AMT: 'Total Eligible core deficiency amount',
  TOTAL_NON_ELIGIBLE_CORE_DEF_AMT: 'Total Non-Eligible core deficiency amount',
  GRAND_TOTAL: 'Grand total core deficiency amount',
  GEN_QR: 'Generate QR code',
  QR_GEN_SUCC: 'QR Code generated successfully.',
  PRINT: 'Print',
  DOWNLOAD: 'Download',
  NO_DATA_FOUND: 'No Data Found',
  GRN_APPROVED: 'GRN has been acknowledged',
  DISAGREE: 'Disagree',
  AGREE: 'Agree',
  DISAGREED_TO_CORE_AMOUNT: 'Disagreed to core deficiency amount',
  AGREED_TO_CORE_AMOUNT: 'Agreed to core deficiency amount',
  MORE_REPLIES_REMAINING: 'more replies remaining',
  GR_GEN_DATE: 'GR Generation Date',
  GR_ACK_DATE: 'GR Acknowledgement Date',
  SAP_TXN: 'SAP txn MB02 status',
  VENDOR_CODE: 'Vendor Code',
  EXTERNAL_INSPECTION_DATE: 'External Insp Date',
  INTERNAL_INSPECTION_DATE: 'Internal Insp Date',
  LC_AMOUNT: 'LC Amount',
  CHEQUE_NO: 'Cheque Number',
  CLEARING_DATE: 'Clearing Date',
  PAYMENT_TERM: 'Payment Term',
  SAP_PAYT_STATUS: 'SAP Payt Status',
  SUMM_DOC_REF_NO: 'Summary doc ref number.',
  CORE_TRANSIT_STATUS: 'Core Transit Status',
  REFERENCE_NO: 'Reference Number',
  DEBIT_NOTE_DETAILS: 'Debit note details',
  DEBIT_NOTE_TEXT_DESC: 'Debit note text description',
  NO_CHAT_AVAILABLE: ' No chat available',

  //dealer cl-4
  INVOICE_UPLOAD: 'Digitally signed invoice upload',
  ADD_INVOICE: 'Add Invoice',
  ADD_EWAY: 'Add E-Way Bill',
  TAP_TO_UPLOAD_ATCH: 'Tap to upload attachment',
  TAP_TO_CHALLAN: 'Tap to upload Challan/551C form',
  TAP_TO_EWAY: 'Tap to upload E-Way Bill',
  PREVIEW: 'Preview',
  NO_ATCH_UPLOADED: 'No attachment uploaded',
  PDF_MAX_30: 'PDF (MAX 30MB)',
  REUPLOAD_INVOICE: 'Re-Upload Invoice',

  //dealer cl-2
  IMAGES_APPROVED: 'Images Approved',
  IMAGES_REJECTED: 'Images Rejected',
  APPROVAL_PENDING: 'Approval Pending',
  SAMPLE_IMAGES: 'Sample Images',
  SAMPLE_PHOTOS: 'Sample Photos',
  TAP_TO_UPLOAD_IMG: 'Tap to upload image with Serial No',
  IMG_TYPES: 'PNG, JPG and HEIC (Max 10MB each)',
  OR: 'OR',
  OPEN_CAMERA: 'Open Camera',
  INVOICE: 'Invoice',
  CORE_IMAGES_APPROVAL_FROM_L1_TEAM: 'Core Image Approval from L1 team',
  UPLOAD_IMAGES: 'Upload Images',
  REUPLOAD_IMAGES: 'Re-Upload Images',
  REASON_FOR_REJECTION: 'Reason for Rejecting',
  REASON_FOR_APPORVAL: 'Reason for Approving',
  IMAGES_SENT_FOR_APPROVAL: 'Images sent for approval',
  UPLOAD_AT_2_IMAGES_AND_MAX_4_IMAGES: 'Upload at least 2 images and max 4',
  UPLOAD_AT_3_IMAGES_AND_MAX_6_IMAGES: 'Upload at least 3 images and max 4',
  ADD_CORE_IMAGES: 'Add core images',

  //dealer cl-1
  YES: 'Yes',
  NO: 'No',
  UPLOAD_DEF_IMAGES: 'Upload Images',
  EDIT_RESP: 'Edit Response',
  ABOVE_RESP_PRESENT: 'Are the symptoms present?',
  ABOVE_COND_PRESENT: 'Are the above conditions present?',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  SAVE: 'Save',
  TOTAL_CORE_DEF_AMT: 'Total Core deficiency amount:',
  ONLY_4_IMAGES_ARE_ALLOWED: 'You can upload a maximum of 4 images. Please select 4 or fewer.',
  DEF_CHECKLIST: 'Deficiency Checklist',
  FILE_TYPE_NOT_SUPPORTED: 'Invalid file format',
  FILE_TYPE: 'Please upload a file in PDF format only.',
  IMAGES_NOT_UPLOADED: 'Images for this core has not been uploaded yet.',

  //dealer-core-def-checklist
  JOB_CARD_DATE: 'Job Card Date',
  PROLIFE_SRNO: 'Prolife Sr. No.',
  CORE_PARTNO: 'Core Part No.',
  MODEL: 'Model',
  CUST_PO: 'Customer P.O. No.',
  CHASSIS_NO: 'Chassis No.',
  INVOICE_NO: 'Invoice No.',
  INVOICE_DATE: 'Invoice Date',
  CORE_TYPE: 'Core Type',
  PAYMENT_METHOD: 'Payment Method',
  WARRANTY_EXP: 'Warranty Expired',
  GR_NO: 'GR No.',
  CORE_SUCC_COMP: 'Core Successfully Completed',
  GEN_PDF: 'Generate PDF',
  GEN_SUMM_DOC: 'Generate Summary Document',
  MOVE_TO_NEXT: 'Move to next step ',
  CLOSE_DEF: 'Close deficiency checklist',
  CONTINUE: 'Continue',
  BACK: 'Back',
  BACK_TO_LISTING: 'Back to listing page',

  //distributor-list
  DEALER_NAME: 'Dealer Name',
  DISTRIBUTOR_LIST: 'Distributor List',
  DEALER_LIST: 'Dealer List',
  AREA_OFFICE: 'Area Office',
  RESET: 'Reset',
  APPLY: 'Apply',
  DEALER_CODE: 'Dealer Code',
  CORE_PART_NO: 'Core Part No.',
  AGE: 'Age',
  DESP_PLANT: 'Desp Plant',
  CORE_READINESS_DATE: 'Core Readiness Date',
  SELECT_DOWNLOAD_OPTION: 'Select Download Options :',
  CONFIRM: 'Confirm',
  ADD_CORE_ITEM: 'Add Cores',
  SELECTED_CORE: 'Selected Cores',
  VIEW_SELECTED: 'View core details',
  CHALLAN_NO: 'Delivery challan no.',
  CHALLAN_DATE: 'Delivery challan date',
  TRUCK_NO: 'Truck No.',
  TRANSPORTER: 'Transporter',
  PWB_NO: 'RR/GCN/PWB No.',
  TOTAL_QTY: 'Total Qty(Nos)',
  SUPPLY_PLACE: 'Place of Supply',
  VERIFICATION_PROG: 'Invoice Verification in progress...',
  INVOICE_ERROR: 'Invoice Errors',
  INVOICE_VERIFIED: 'Invoice verified successfully',
  INVALID_FILE: 'Invalid File Format',
  INVALID_FILE_ERROR: 'Please upload a file in PDF format only.',
  UPLOAD_SUCCESSFUL: 'Invoice uploaded successfully',
  SURE_DELETE: 'Are you sure you want to delete the core ?',
  SELECTED_CORE_DETAILS: 'Selected core details',
  ACKNOWLEDGE_CORES: 'Acknowledge cores',
  SELECT_ALL: 'Select all',
  NO_OF_CORES: 'No of Cores',
  INVOICE_UPLOAD_DISTRIBUTOR: 'Digitally signed 551c PDF upload',

  // L1 Flow
  BACK_CORE_IMAGE_APPROVAL: 'Back / Core Image Approval',
  CORE_PACKING_IMAGES: 'Core Packaging Images',
  REASON_FOR: 'Reason for',
  APPROVAL: 'approval',
  REJECTION: 'rejection',
  UPLOAD: 'Upload',
  LOG: 'Log',
  ACTION_BY: 'Action by',
  STATUS: 'Status',
  ACTION_AT: 'Action at',
  REASON_REQUIRED_FOR_REJECTION: 'Reason is required for rejection',
  MAX_300: 'Maximum 300 characters allowed',
  WHITE_SPACES: 'White spaces are not allowed',
  IMAGES: 'Images',
  CORE_INVOICE_DATE: 'Core invoice date',

  // Header
  HELLO: 'Hello',
  ARE_YOU_SURE_YOU_WANT_TO_LOGOUT: 'Are you sure you want to Logout ?',
  TOTAL_NOTIFICATIONS: 'Total notifications today',
  NO_NEW_NOTS: 'No new notifications',
  SHOW_ALL: 'Show all notifications',
  NOTIFICATION_LIST: 'List of notifications',

  //PDF
  QNO: 'Q.No.',
  QUESTION: 'Checklist Question',
  ANSWER: 'Yes/No',
  SR_NO: 'Sr No.',
  DATE: 'Date :',
  TIME: 'Time :',
  CORE_DEF_CHECKLIST: 'Core Deficiency Checklist Summary',
  CORE_ITEM: 'Core Item',

  //plant-core-list
  DEALER_KPIS: 'Dealer Dashboard',
  DISTRIBUTOR_KPIS: 'Distributor Dashboard',
  TML_PLANT_KPIS: 'TML Plant Dashboard',
  LAKH: 'Lakh',

  // Technician
  DEALER_CDC: 'Dealer Core Deficiency Checklist',
  DEALER_GSTIN: 'Dealer GSTIN',
  DOUBLE_HYPHEN: '--',
  ADD_OTHER: 'Add other part deficiency',
  STATE: 'State',
  TYPE: 'Type',
  REGION: 'Region',
  CORE_AGEING: 'Core Ageing',
  TECH_CDC: 'External Core Deficiency Checklist',
  ANSWER_RADIO: 'Answer',
  TECH_CDC_INT: 'Internal Core Deficiency Checklist',
  SERIAL_NUM: 'Enter Core Registration Number: ',
  SN_REQ: 'Serial number required',
  SERIAL_NUMBER: 'Serial Number',
  VIDEO_COUNT: 'Maximum 2 videos allowed to upload in chat',
  VIDEO_SIZE: 'Video size should be under 30Mb',
  PLEASE_WAIT: 'Please wait...',
  //Notification
  NOTIFICATION_TYPE: 'Notififcation type',
  NOTIFICATION_DETAILS: 'Notification details',
  NOTIFICATION_TIME: 'Reported at',
  NOTIFICAIONS: 'Notifications',

  //sitekey
  // SITEKEY: environment.siteKey,
  // SECRETKEY: environment.secretKey,
  // IV: environment.iv,
  // PUBLIC_KEY: environment.publicKey,
  // PRIVATE_KEY: environment.privateKey,
  // PRIVATE_KEY_2: environment.privateKey2,
  DEVTOOLS: environment.devtools,
  // PRIVATE_KEY_LOGIN: environment.privateKeyLogin,

  //cht-new
  CONCLUDE: 'Conclude',
};
export const API_URL = environment.reportingServiceUrl;

export const API_ENDPOINT = {
  GET_DEALER_CORE_LIST: '/api/reporting-service/cores/',
  GET_L1_CORE_LIST: '/api/reporting-service/L1/fetch-l1-listing/',
  GET_KPI_DEALER: '/api/reporting-service/cores/kpi/',
  GET_PRICELIST: '/api/reporting-service/cdc/pricelisting/',
  GET_KPI_DISTRIBUTOR: '/api/reporting-service/distributor/kpi/',
  GET_CORE_DETAILS: '/api/reporting-service/cores/',
  GET_CORE_DETAILS_V2: '/api/reporting-service/cores-v2/',
  GET_DEALER_LIST: '/api/reporting-service/fetch-dealer/',
  GET_FILTER_PARAMS: '/api/reporting-service/cdc/filter-params/',
  GET_STATE_OFFICE: '/api/reporting-service/fetch-state-offices/',
  GET_CHECKLIST: '/api/reporting-service/cdc/get-checklist/',
  SAVE_ANSWER: '/api/reporting-service/cdc/save-answer/',
  UPDATE_DEFICIENCY_AMOUNT: '/api/reporting-service/cdc/update-deficiency-amount/',
  GET_DEFICIENCY_AMOUNT: '/api/reporting-service/cdc/get-deficiency-amount/',
  REJECT_CORE: '/api/reporting-service/update-core-status/',
  CDC_COMPLETED: '/api/reporting-service/mark-cdc-performed/',
  UPLOAD_UPDATE_IMAGES: '/api/reporting-service/L1/upload-update-images/',
  GET_APPROVAL_STATUS: '/api/reporting-service/L1/get-approval-status/',
  FETCH_CHECKLIST: '/api/reporting-service/chat/fetch-checklist/',
  SAVE_TML_CDC_ANSWER: '/api/reporting-service/chat/save-tml-cdc-answer/',
  CREATE_CHAT: '/api/reporting-service/chat/create-chat/',
  SAVE_MESSAGES_CHAT: '/api/reporting-service/chat/save-messages/',
  FETCH_CHAT: '/api/reporting-service/chat/fetch-chat/',
  FETCH_L1_KPI: '/api/reporting-service/L1/fetch-l1-kpi/',
  FETCH_TECH_KPI: '/api/reporting-service/chat/technician-kpi/',
  CLOSE_CONCLUDE_CHAT: '/api/reporting-service/chat/close-conclude-chat/',
  UPDATE_CHECKLIST_STATUS: '/api/reporting-service/chat/checklist-status/',
  ACK_CORES: '/api/reporting-service/distributor/reached-distributor/',
  GET_CORE_TRACKING: '/api/reporting-service/cores/tracking/',
  FETCH_TRACKING: '/api/reporting-service/cores/fetch-tracking/',
  FETCH_LOGIN_DATA: '/api/reporting-service/wrapper/fetch-login-data/',
  OCR_INVOICE_VALIDATION: '/api/reporting-service/distributor/validate-invoice/',
  TML_PLANT_KPI: '/api/reporting-service/cdc/tml-plant-kpi/',
  TML_PLANT_LISTING: '/api/reporting-service/cdc/tml-plant-listing/',
  VALIDATE_551C: '/api/reporting-service/distributor/validate-551c/',
  VALIDATE_551C_EWAY: '/api/reporting-service/distributor/validate-551c-eway/',
  SAVE_QR: '/api/reporting-service/save-qr-code/',
  FETCH_QR: '/api/reporting-service/fetch-qr-code/',
  SAVE_OTC: '/api/reporting-service/distributor/save-invoice/',
  FETCH_OTC: '/api/reporting-service/distributor/fetch-invoice/',
  SAVE_EMAIL: '/api/reporting-service/cdc/save-fg-email/',
  SAVE_551C_FORM: '/api/reporting-service/distributor/save-551c-form/',
  FETCH_FG_EMAIL: '/api/reporting-service/cdc/fetch-fg-email/',
  CHECK_2FA: '/api/reporting-service/twofactorauth/check_twofa_status/',
  CHECK_2F_A: '/api/reporting-service/wrapper/check-2fa-status/',
  VERIFY_2F_A: '/api/reporting-service/twofactorauth/authorize-2fa/',
  FETCH_PENDING_TECHNICIAN: '/api/reporting-service/chat/fetch-pending-technician/',
  REACHED_TECHNICIAN: '/api/reporting-service/chat/reached-technician/',
  UPDATE_SERIAL_NUMBER: '/api/reporting-service/chat/update-serial-number/',
  FETCH_SERIAL_NUMBER: '/api/reporting-service/chat/fetch-serial-number/',
  UPLOAD_EXCEL: '/api/reporting-service/L1/save-excel/',
  SAVE_BILLING_EXCEL: '/api/reporting-service/L1/save-biling-excel/',
  SAVE_DEBIT_EXCEL: '/api/reporting-service/L1/save-debit-excel/',
  SAVE_GR_ACK_EXCEL: '/api/reporting-service/L1/save-gr_ack-excel/',
  SAVE_GR_EXCEL: '/api/reporting-service/L1/save-gr-excel/',
  MAPPIND_EXCEL: '/api/reporting-service/L1/save-mapping-excel/',
  FETCH_CTRD: '/api/reporting-service/distributor/fetch-551c-form/',
  SAVE_DISTRIBUTOR_EMAIL: '/api/reporting-service/distributor/save-distributor-email/',
  FETCH_DISTRIBUTOR_EMAIL: '/api/reporting-service/distributor/fetch-distributor-email/',
  SEND_EMAIL: '/api/reporting-service/wrapper/send-test-email/',
  REGISTER_USER: '/api/reporting-service/twofactorauth/register_user/',
  VERIFY_TOTP: '/api/reporting-service/twofactorauth/verify_totp/',
  REGISTER_TWO_FA: '/api/reporting-service/twofactorauth/registertwoFA/',
  SEND_EMAIL_DISTRIBUTOR: '/api/reporting-service/wrapper/send-email-distributor/',
  SAVE_DEALER_EMAILS: '/api/reporting-service/cdc/save-dealer-emails/',
  GENERATE_REF_NUMBER: '/api/reporting-service/cdc/generate-reference-number/',
  FETCH_DEALER_EMAILS: '/api/reporting-service/chat/fetch-dealer-email/',
  GET_DEALER_LOCATION: '/api/reporting-service/fetch-dealer-address/',
  SAVE_NOTIFICATION: '/api/reporting-service/save-notification/',
  FETCH_NOTIFICATION: '/api/reporting-service/fetch-notifications/',
  CHECK_MAIL_STATUS: '/api/reporting-service/check-mail-status/',
};
/* OBFUSCATE_END */

